import { useQuery } from "@apollo/react-hooks"
import { useEffect, useState } from "react"
import classNames from "classnames"
import { metadata, SVOD_BLOCK_TEXT, FEATURE_PARTNERS } from "lacinetek-common/src/metadata"
import HtmlParser from "react-html-parser"

import { useTranslation } from "lib/i18n/translation"
import { isAvailable as isAvailableFn } from "lib/tools/availability"
import { useCountry } from "lib/country"
import { useCart } from "lib/cart"
import { PARTNERS } from "lib/tools/categories-list"
import { FETCH_PARTNER_CATEGORIES } from "lib/graphql/queries"

import Image from "components/common/image"
import { SubscribeButton } from "components/common/subscribe-button"

const PartnerCard = ({ partner, contentMeta, displayButton, subscriptionType }) => {
	const contentBuilder = (key, value, index) => {
		switch (key) {
			case "title":
				return <h2 key={index}>
						<b>{HtmlParser(value)}</b>
						{contentMeta.logo_url && (
							<a
								href={contentMeta.logo_link_url}
								target="_blank"
								title={contentMeta.name}
								style={{ padding: 0 }}
							>
								<Image src={contentMeta.logo_url} className="logo" alt={`Logo - ${partner.name}`} />
							</a>
						)}
					</h2>
			case "subscription_button":
				return displayButton && <div>
						<SubscribeButton type={subscriptionType}  key={index}/>
					</div>
			case "offer_title":
				return <div key={index}><p className="excerpt"><b>{HtmlParser(value)}</b></p><br /></div>
			case "offer_desc":
				return <p key={index}>{HtmlParser(value)}</p>
			case "selection_title":
			case "about_title":
				return <h3 className="title" key={index}>{HtmlParser(value)}</h3>
			case "selection":
			case "about":
				return <p key={index}>{HtmlParser(value)}</p>
			default:
		}
	}

	return (
	<section className="block red partnership">
		<div className="splitted vertical-centered">
			{partner && (
				<aside className="centered">
					<figure className="full">
						<picture>
							<Image src={partner.images[0].source} alt={partner.name} />
						</picture>
					</figure>
					<p className="credits" dangerouslySetInnerHTML={{ __html: contentMeta.img_credit }}></p>
				</aside>
			)}
			<div className="content">
				{Object.entries(contentMeta).map(([key, value], index) => contentBuilder(key, value, index))}
			</div>
		</div>
	</section>
)}

export const PartnerBanner = ({ query }) => {
	const slug = Object.keys(query).filter(name => name !== "lang")

	if (slug.length === 0) {

		return null
	}

	const { c } = useTranslation("common")
	const { subscriptions } = useCart()
	const { filterCountry: country } = useCountry()
	const { data } = useQuery(
		FETCH_PARTNER_CATEGORIES,
		{
			variables: {
				query: `parent: ${process.env.CATEGORIES.find(c => c.key === PARTNERS).id} AND linkRewrite.value: ${slug[0]}`
			},
			fetchPolicy: "network-only"
		}
	)

	const [isOpen, setIsOpen] = useState(true)
	const [partner, setPartner] = useState()
	const [contentMeta, setContentMeta] = useState({})
	const [displayButton, setDisplayButton] = useState(false)
	const [subscriptionType, setSubscriptionType] = useState("")

	useEffect(
		() => {
			setPartner(data?.cms.categories.items[0])
		},
		[data]
	)

	useEffect(
		() => {
			if (!partner) {
				return
			}

			const content = metadata(partner, FEATURE_PARTNERS)

			if (!content) {
				return
			}

			const contentMeta = {}

			content.split(';').forEach(meta => {
				meta.split(';').forEach(meta => {
					const key = meta.includes("[") ? meta.split("[")[0] : ""
					const value = meta.includes("[") ? meta.split("[")[1].replace("]", "") : meta
					contentMeta[key] = value
				})
			})

			if (contentMeta.subscription_button !== "") {
				const subscription = subscriptions.find(sub => sub.name === contentMeta.subscription_button)

				if (subscription) {
					const type = country.subscriptions.find(sub => sub.id == subscription.id)

					if (type) {
						if (type.key !== subscriptionType) {
							setSubscriptionType(type.key)
						}
					}
				}
			}

			setContentMeta(contentMeta)
		},
		[partner]
	)

	useEffect(
		() => {
			if (subscriptionType !== "" && !displayButton) {
				setDisplayButton(true)
			}
		},
		[subscriptionType]
	)

	if (!isAvailableFn(partner)) {
		return null
	}

	if (Object.keys(contentMeta).length === 0) {
		return null
	}

	return (
		<nav
			className="contextual sticky"
			aria-label="navigation contextuelle de l'abonnement"
		>
			<div className="banner red">
				<div className="banner-content centered">
					<div className="splitted alt inline">
						{HtmlParser(metadata(partner, SVOD_BLOCK_TEXT))}
						<nav className="buttons small min">
							<a
								href="#svod-partnership"
								rel="nofollow noopener"
								title={isOpen ? c("close") : c("learn-more-about")}
								data-collapse-close={c("close")}
								data-collapse-open={c("learn-more-about")}
								className={classNames("collapsible-toggle", { active: isOpen })}
								onClick={event => {
									event.preventDefault()
									setIsOpen(!isOpen)
								}}
							>
								{isOpen ? c("close") : c("learn-more-about")}
							</a>
						</nav>
					</div>
				</div>
				<div className="banner-extras">
					<div
						id="svod-partnership"
						className={classNames("collapsible fixed", { active: isOpen })}
					>
						<PartnerCard
							partner={partner}
							contentMeta={contentMeta}
							displayButton={displayButton}
							subscriptionType={subscriptionType}
						/>
					</div>
				</div>
			</div>
		</nav>
	)
}
